import initialState from './technicianInitialState';
import mutations from './technicianMutation';
import actions from './technicianAction';

const getters = {
  technicianFilters: (state) => {
    const {
      filters,
      partnerSettings,
    } = state;
    let newFilters = JSON.parse(JSON.stringify(filters));

    if (partnerSettings?.TECH_MYTECH_SETTINGS !== 'yes') {
      newFilters = newFilters.filter((f) => f.key !== 'myTech');
    }

    return newFilters;
  },
  isPendingActive(state) {
    const {
      filters,
    } = state;
    const statusFilter = filters.find((filter) => filter.key === 'status');
    return statusFilter?.activeOption.value === 'Pending';
  },
  technicianBranches: (state, getter, rootState) => {
    const {
      bulkBranchFilters,
    } = state;
    const {
      admin: {
        partnerList,
      },
    } = rootState;

    let copy = _.cloneDeep(bulkBranchFilters);

    if (partnerList.length) {
      copy = copy.map((lf) => {
        if (lf.key === 'branch') {
          lf.options = partnerList.map((ab) => ({
            label: ab.corporationName,
            value: ab.id,
          }));
          lf.showOnAll = true;
        }
        return lf;
      });
    }
    return copy;
  },
};

const technicianModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default technicianModule;
